import { Select } from '../../../components'
import { useSelectedFieldToUpdate } from '../../../lib'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { CreateDateField } from '@indigohive/cogfy-types'
import { FieldConfigurationsProps } from '../FieldConfigurations'

export function CreateDateConfigurations (props: FieldConfigurationsProps) {
  const { state, controller } = props

  const { t } = useTranslation()
  const field = useSelectedFieldToUpdate(state) as CreateDateField
  const [dateFormat, setDateFormat] = useState(getDate(field.data?.createDate?.format))
  const [hourFormat, setHourFormat] = useState(getHour(field.data?.createDate?.format))

  useEffect(() => {
    setDateFormat(getDate(field.data?.createDate?.format))
    setHourFormat(getHour(field.data?.createDate?.format))
  }, [field.data])

  return (
    <>
      <Select
        label={t('editFieldDrawer:Date format')}
        size="md"
        value={dateFormat}
        onChange={event => {
          controller.onUpdateFieldData(
            field.id,
            { createDate: { ...field.data?.createDate, format: `${event.target.value}${hourFormat}` } }
          )
          setDateFormat(event.target.value)
        }}
        options={[
          { label: t('editFieldDrawer:Month/Day/Year'), value: 'P' },
          { label: t('editFieldDrawer:Month Day, Year'), value: 'PPP' },
          { label: t('editFieldDrawer:Full date'), value: 'PPPP' }
        ]}
      />
      <Select
        label={t('editFieldDrawer:Hour format')}
        size="md"
        value={hourFormat}
        onChange={event => {
          controller.onUpdateFieldData(
            field.id,
            { createDate: { ...field.data?.createDate, format: `${dateFormat}${event.target.value}` } }
          )
          setHourFormat(event.target.value)
        }}
        options={[
          { label: t('Hidden'), value: '' },
          { label: t('editFieldDrawer:Hours.Minutes'), value: 'p' },
          { label: t('editFieldDrawer:Hours.Minutes.Seconds'), value: 'pp' }
        ]}
      />
    </>
  )
}

const getDate = (format?: string) => format?.match(/P+/) ? format?.match(/P+/)![0] : 'P'
const getHour = (format?: string) => format?.match(/p+/) ? format?.match(/p+/)![0] : ''
